import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, matchPath  } from "react-router-dom";
import { useEffect, useRef } from "react";
import SignUpForm from "./pages/SignUpForm";
import NotFound from "./pages/NotFound";
import Home from "./pages/Home";
import Corporate from "./pages/Corporate";
import Login from "./pages/Login";
import Sso from "./pages/Sso";
import Auth from "./pages/Auth";

import SidebarLayout from "./layouts/SidebarLayout";
import TopNavLayout from "./layouts/TopNavLayout";
import Register from "./pages/Register";

import {TransitionGroup, CSSTransition, SwitchTransition} from "react-transition-group";
import "./styles/transitions.scss";
import "./styles/badges.scss";
import "./styles/card.scss";
import ListenerDashboard from "./pages/ListenerDashboard";
import PodcasterDashboard from "./pages/PodcasterDashboard";
import PodcasterPodcastClub from "./pages/PodcasterPodcastClub";
import eventBus from "./services/eventBus";
import GlobalToast from "./components/GlobalToast";
import GlobalAudioPlayer from "./components/GlobalAudioPlayer";
import GlobalUserInfoModal from "./components/GlobalUserInfoModal";
import BugReportWidget from "./components/BugReportWidget";
import { useAuthStore } from "./store/store";
import Wizard from "./pages/Wizard";
import TranscribeTest from "./pages/TranscribeTest";
import QuizTopicPromptTest from "./pages/QuizTopicPromptTest";
import Resources from "./pages/Resources";
import ListenerClubsToJoin from "./pages/ListenerClubsToJoin";
import ListenerClub from "./pages/ListenerClub";
import ListenerPodcastClub from "./pages/ListenerPodcastClub";
import ListenerEpisode from "./pages/ListenerEpisode";
import AdminDashboard from "./pages/AdminDashboard";
import ListenerDiscussion from "./pages/ListenerDiscussion";
import PodcasterDiscussion from "./pages/PodcasterDiscussion";
import ListenerPodcasterClubs from "./pages/ListenerPodcasterClubs";
import ListenerPractices from "./pages/ListenerPractices";
import Join from "./pages/Join";
import Profile from "./pages/Profile";
import PodcasterProfile from "./pages/PodcasterProfile";
import TestImage from "./pages/TestImage";
import AfterTheDownload from "./pages/AfterTheDownload";
import Impersonate from "./pages/Impersonate";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Audit from "./pages/Audit";
import Call from "./pages/Call";
import CallConfirmed from "./pages/CallConfirmed";
import Demo from "./pages/Demo";
import Build from "./pages/Build";

function AuthRedirect() {
    const navigate = useNavigate();

    useEffect(() => {
        const handler = () => navigate("/login");
        eventBus.on("unauthorized", handler);
        return () => eventBus.off("unauthorized", handler);
    }, [navigate]);

    return null;
}

function AnimatedRoutes() {
    const location = useLocation();
    const nodeRef = useRef({});

    return (
        <TransitionGroup component={null}>
            <SwitchTransition mode="out-in">
                <CSSTransition
                    key={location.pathname}
                    classNames="fade"
                    timeout={300}
                    unmountOnExit
                    nodeRef={nodeRef}
                >
                    <div ref={nodeRef}
                         className="route-wrapper dark">
                        <Routes location={location}>
                            {/* Top-nav layout pages */}
                            <Route element={<TopNavLayout/>}>
                                <Route path="/" element={<Home/>}/>
                                <Route path="/corporate" element={<Corporate/>}/>
                                <Route path="/signup" element={<SignUpForm/>}/>
                                <Route path="/login" element={<Login/>}/>
                                <Route path="/sso" element={<Sso/>}/>
                                <Route path="/register" element={<Register/>}/>
                                <Route path="/auth" element={<Auth/>}/>
                                <Route path="/forgot-password" element={<ForgotPassword/>}/>
                                <Route path="/reset-password" element={<ResetPassword/>}/>
                                <Route path="/join" element={<Join/>}/>
                                <Route path="/trans" element={<TranscribeTest/>}/>
                                <Route path="/listener-dashboard" element={<ListenerDashboard/>}/>
                                <Route path="/profile" element={<Profile/>}/>
                                <Route path="/listener-clubs" element={<ListenerClubsToJoin/>}/>
                                <Route path="/listener-podcaster/:guid" element={<ListenerPodcasterClubs/>}/>
                                <Route path="/listener-podcast-club/:guid" element={<ListenerPodcastClub/>}/>
                                <Route path="/listener-podcast-club/:guid/discussion/:discussionGuid" element={<ListenerDiscussion/>}/>
                                <Route path="/listener-episode/:podcastClubId/:episodeId" element={<ListenerEpisode/>}/>
                                <Route path="/listener-practices" element={<ListenerPractices/>}/>
                                {/*<Route path="/listener-clubs/:guid" element={<ListenerClub/>}/>*/}
                                <Route path="/podcaster-dashboard" element={<PodcasterDashboard/>}/>
                                <Route path="/podcaster/profile" element={<PodcasterProfile/>}/>
                                <Route path="/podcaster/podcast-club/:guid" element={<PodcasterPodcastClub/>}/>
                                <Route path="/podcaster/podcast-club/:guid/discussion/:discussionGuid" element={<PodcasterDiscussion/>}/>
                                {/*<Route path="/podcaster-dashboard/podcast-clubs" element={<PodcasterDashboard/>}/>*/}
                                <Route path="/wizard/:step?/:id?" element={<Wizard/>}/>
                                <Route path="/quiz-topic-prompt-test" element={<QuizTopicPromptTest/>}/>
                                <Route path="/resources" element={<Resources/>}/>
                                <Route path="/test-image" element={<TestImage/>}/>
                                <Route path="/admin" element={<AdminDashboard/>}/>
                            </Route>

                            {/* Sidebar layout pages */}
                            {/*<Route element={<SidebarLayout/>}>*/}
                            {/*     Example deeper nesting: */}
                            {/*     <Route path="/dashboard/profile" element={<Profile />} /> */}
                            {/*     <Route path="/dashboard/settings" element={<Settings />} /> */}
                            {/*</Route>*/}

                            {/* Fallback */}
                            <Route path="/afterthedownload" element={<AfterTheDownload/>}/>
                            <Route path="/impersonate" element={<Impersonate/>}/>

                            {/* Public lead-magnet pages — no auth, no nav, not linked from anywhere yet */}
                            <Route path="/audit" element={<Audit/>}/>
                            <Route path="/call" element={<Call/>}/>
                            <Route path="/call-confirmed" element={<CallConfirmed/>}/>
                            <Route path="/demo" element={<Demo/>}/>
                            <Route path="/build" element={<Build/>}/>

                            <Route path="*" element={<NotFound/>}/>
                        </Routes>
                    </div>
                </CSSTransition>
            </SwitchTransition>
        </TransitionGroup>
    );
}

// Standalone routes that should render with NO app chrome (no nav, no audio player, no auth redirect)
const STANDALONE_PATHS = ['/afterthedownload', '/impersonate', '/audit', '/call', '/call-confirmed', '/demo', '/build'];

function AppChrome() {
    const { token } = useAuthStore();
    const { pathname } = useLocation();

    if (STANDALONE_PATHS.includes(pathname)) return null;

    return (
        <>
            <GlobalToast />
            {token && <GlobalUserInfoModal />}
            {token && <GlobalAudioPlayer />}
            {/*<BugReportWidget />*/}
            <AuthRedirect />
        </>
    );
}

function App() {
    return (
        <Router>
            <AppChrome />
            <AnimatedRoutes />
        </Router>
    );
}

export default App;
